import styled, { css } from 'styled-components';

import { breakpoints, theme, Grid } from '@notino/react-styleguide';

import { RowWrapper, ViewPort } from '@components';

export const Main = styled.div``;

export const Clear = styled.div`
  clear: both;
`;

export const ProductTabContentGrid = styled(Grid)<{
  newPdDesignEnabled: boolean;
}>`
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled &&
    css`
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 2rem;
      @media (min-width: ${breakpoints.lg}) {
        padding-left: 0.9375rem;
        padding-right: 0.9375rem;
        margin-bottom: 4rem;
      }
    `}
`;

export const TopSection = styled(RowWrapper)<{ newPdDesign: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ newPdDesign }) => css`
    @media (min-width: ${newPdDesign ? breakpoints.lg : breakpoints.md}) {
      flex-direction: row;
    }
  `}
`;

export const GalleryWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          @media (min-width: ${breakpoints.md}) {
            width: 100%;
          }
          @media (min-width: ${breakpoints.lg}) {
            height: 100%;
            margin-top: 2.5rem;
            padding-right: 2rem;
            width: 65%;
          }
          @media (min-width: ${breakpoints.xl}) {
            width: 70%;
          }
        `
      : css`
          @media (min-width: ${breakpoints.md}) {
            width: 42%;
            margin-top: 1rem;
            padding-right: 2rem;
          }
        `}
`;

export const MainInfoWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          @media (min-width: ${breakpoints.md}) {
            width: 100%;
          }
          @media (min-width: ${breakpoints.lg}) {
            width: 35%;
          }
          @media (min-width: ${breakpoints.xl}) {
            width: 30%;
          }
        `
      : css`
          @media (min-width: ${breakpoints.md}) {
            width: 58%;
          }
        `}
`;

export const PDViewPort = styled(ViewPort)<{ newPdDesignEnabled: boolean }>`
  ${({ newPdDesignEnabled }) =>
    !newPdDesignEnabled &&
    css`
      padding-left: 16px;
      padding-right: 16px;
    `}
`;

export const TitleCSS = css<{ newPdDesignEnabled: boolean }>`
  text-align: left !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  flex-basis: 100%;

  font-size: 1rem;
  line-height: 1.18;

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          font-weight: 500;
          @media (min-width: ${breakpoints.lg}) {
            ${theme.typography.titleLarge};
          }
        `
      : css`
          font-weight: bold;
          margin: 0.625rem 0 !important;
        `}

  @media (min-width: ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled ? breakpoints.lg : breakpoints.md}) {
    ${({ newPdDesignEnabled }) =>
      !newPdDesignEnabled &&
      css`
        font-size: 1.75rem !important;
        margin: 3rem 0 1.75rem !important;
      `}

    display: block;
    cursor: text;
  }
`;

export const TitleWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  ${TitleCSS};

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled &&
    css`
      padding-left: 0.9375rem;

      @media (min-width: ${breakpoints.lg}) {
        padding-left: 0;
      }
    `}
`;

export const ProductTitleWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  text-align: left;
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  cursor: pointer;
  flex-basis: 100%;
  width: 100%;
  margin: 0.625rem 0 !important;

  font-size: 1rem;
  line-height: 1.18;

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          display: flex;
          padding-left: 0.9375rem;
          font-weight: 500;
          @media (min-width: ${breakpoints.lg}) {
            padding-left: 0;
            ${theme.typography.titleLarge};
          }
        `
      : css`
          font-weight: bold;
          @media (min-width: ${breakpoints.md}) {
            font-size: 1.75rem;
          }
        `}

  @media (min-width: ${breakpoints.md}) {
    cursor: text;
  }
`;

interface IDescriptionTitleProps {
  fullWidth: boolean;
}

export const DescriptionTitle = styled.div<{
  newPdDesignEnabled: boolean;
  fullWidth: boolean;
}>`
  ${({ newPdDesignEnabled, fullWidth }) =>
    newPdDesignEnabled
      ? css`
          width: 100%;
          @media (min-width: ${breakpoints.lg}) {
            width: ${fullWidth ? '100%' : '65%'};
          }

          @media (min-width: ${breakpoints.xl}) {
            width: ${fullWidth ? '100%' : '70%'};
          }
        `
      : css`
          @media (min-width: ${breakpoints.md}) {
            width: ${(props: IDescriptionTitleProps) =>
              props.fullWidth ? '100%' : '66%'};
            padding-right: ${(props: IDescriptionTitleProps) =>
              props.fullWidth ? '0' : '2rem'};
          }
        `}
`;

export const CompositionTitle = styled.div`
  max-width: 66%;
`;

export const CharacteristicsTitle = styled.div<{ newPdDesignEnabled: boolean }>`
  visibility: hidden;

  @media (min-width: ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled ? breakpoints.lg : breakpoints.md}) {
    visibility: visible;

    ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled
        ? css`
            width: 100%;
            @media (min-width: ${breakpoints.lg}) {
              width: 35%;
            }

            @media (min-width: ${breakpoints.xl}) {
              width: 30%;
            }
          `
        : css`
            width: 34%;
          `}
  }
`;

export const TextNormal = styled.span<{ newPdDesignEnabled: boolean }>`
  display: none;

  @media (min-width: ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled ? breakpoints.lg : breakpoints.md}) {
    display: inline;
    ${({ newPdDesignEnabled }) =>
      !newPdDesignEnabled &&
      css`
        font-weight: 300;
      `}
  }
`;

export const CommonContainer = styled.section`
  display: flex;
`;

export const CommonMarginWrapper = styled.div`
  flex-basis: 100%;
  height: inherit;

  @media (min-width: ${breakpoints.md}) {
    margin: 0;
  }
`;

export const PriceWrapper = styled.span``;

export const CurrencyWrapper = styled(PriceWrapper)`
  margin-left: 0.3rem;
  margin-right: 0.3rem;
`;

export const ShowOnDesktop = styled.div<{ newPdDesign?: boolean }>`
  ${({ newPdDesign }) => css`
    display: none;
    @media (min-width: ${newPdDesign ? breakpoints.lg : breakpoints.md}) {
      display: block;
    }
  `}
`;

export const ShowOnMobile = styled.div<{ newPdDesign?: boolean }>`
  ${({ newPdDesign }) => css`
    display: block;
    @media (min-width: ${newPdDesign ? breakpoints.lg : breakpoints.md}) {
      display: none;
    }
  `}
`;

export const ReviewSummaryCount = styled.span`
  margin-left: 0.5rem;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.125rem;
  color: ${theme.palette.neutralDark};
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;
